<template>
  <div class="page-wrapper">
    <h1 class="h2">TOUR Championship Golf Ball Schedule</h1>
    <p>* All times are in EDT</p>
    <div v-if="keys(sptittedUpcomingSchedules).length">
      <Schedule :value="sptittedUpcomingSchedules" />
    </div>

    <br />

    <div v-if="keys(sptittedPastSchedules).length">
      <h2 class="h2">Past events</h2>
      <Schedule :value="sptittedPastSchedules" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "SchedulePage",
  metaInfo: {
    titleTemplate: "%s - Schedule",
  },
  mounted() {
    this.setPageContext("schedule");
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.fetchResource("Schedule");
    },
    splitSchedule(collection) {
      return _.groupBy(collection || [], (schedule) => {
        if (schedule.start_at) {
          return this.$moment(schedule.start_at).format("MMMM Do");
        } else {
          return "TBD";
        }
      });
    },
    keys(obj) {
      return Object.keys(obj);
    },
  },
  computed: {
    ...mapState({
      schedules: (state) => state.page.cache[state.page.active?.id]?.Schedule,
    }),
    sptittedPastSchedules() {
      return this.splitSchedule(this.schedules?.past);
    },
    sptittedUpcomingSchedules() {
      return this.splitSchedule(this.schedules?.upcoming);
    },
  },
};
</script>

<style lang="scss" scoped>
.h2 {
  font-weight: 500;
}

.h1 {
  margin-top: 1em;
}

.edt-time {
  font-size: 18px;
  color: #676767;
  margin-bottom: 2.5em;
}
</style>
